module.exports = __webpack_public_path__ + "static/media/content_black.2f2ec880.svg";